module.exports = __webpack_public_path__ + "img/modelshow05-2.27b2ebd4.png";